export enum SPORTTAB {
  Normal = 1,
  Advanced = 2,
  Master = 3,
}

/** 射门路径：LeftIn/RightIn 进球，LeftOut/RightOut 未进 */
export enum PathKey {
  LeftIn = 'leftin',
  RightIn = 'rightin',
  LeftOut = 'leftout',
  RightOut = 'rightout',
}

export enum RoundStatus {
  Bet = 0,
  Drawing = 1,
  Result = 2,
}

export enum WinType {
  Normal = 1,
  Big = 2,
}

export enum RankTypeEnum {
  Daily = 1,
  Week = 2,
  Month = 3,
}

/** 重复下注可用状态：
 * 1-可以重复下注
 * 2-用户上一轮无下注
 * 3-用户本轮已使用重复下注
 * 4-重复下注将超过最大下注额
 * 5-用户余额不足
 * 6-重复下注将超过最大下注数量
 */
export enum RepeatFlag {
  CanRepeat = 1,
  NoPrevBet = 2,
  UsedThisRound = 3,
  ExceedMaxAmount = 4,
  InsufficientBalance = 5,
  ExceedMaxCount = 6,
}

export enum RESULTSTATUS {
  nopart = 0,
  success = 1,
  fail = 2,
}

/** 足球杯赛阶段：与服务端 current_phase / phase 枚举一致 */
export enum FootballCupPhase {
  NotStarted = 0,
  Qualifying = 1,
  PointsRace = 2,
  HonorDisplay = 3,
  Ended = 4,
}

export enum RewardTypeEnum {
  mini = 1,
  minor,
  major,
}

export const RewardStr = {
  [RewardTypeEnum.major]: 'MAJOR',
  [RewardTypeEnum.minor]: 'MINOR',
  [RewardTypeEnum.mini]: 'MINI',
}

export interface FootballCupWheelTargetItem {
  /** 目标/奖项 ID */
  id: number
  /** 奖品类型：1 特权，2 金币，3 jackpot，4 积分暴击 */
  type: number
  /** jackpot 档位：1 mini，2 minor，3 major（非 jackpot 项可能不存在/为 0） */
  jackpot_type?: number
  /** 积分暴击倍率（非积分暴击项可能不存在/为 0） */
  point_multi?: number
  /** 展示名称 */
  name: string
  /** 展示图标 */
  icon?: string
}

export interface WheelInfo {
  /** 业务错误信息 */
  err_msg: string
  /** 剩余抽奖券数量 */
  tickets: number
  /** mini jackpot 奖池 */
  mini_jackpot_pool: number
  /** minor jackpot 奖池 */
  minor_jackpot_pool: number
  /** major jackpot 奖池 */
  major_jackpot_pool: number
  /** 基础转盘奖项列表 */
  base_wheel: FootballCupWheelTargetItem[]
  /** jackpot 二级转盘奖项列表 */
  jackpot_wheel: FootballCupWheelTargetItem[]
  /** 积分暴击二级转盘奖项列表 */
  point_wheel: FootballCupWheelTargetItem[]
}

// --- football_cup_wheel_draw 返回 data（文档 FootballCupWheel*）---

/** 一级转盘命中结果 */
export interface FootballCupWheelNormalResult {
  /** 命中奖项 ID */
  prize_id: number
  /** 是否进入 jackpot 二级转盘 */
  hit_jackpot: boolean
  /** 是否进入积分暴击二级转盘 */
  hit_point: boolean
}

/** jackpot 二级转盘结果：jackpot_type 1 mini，2 minor，3 major */
export interface FootballCupWheelJackpotResult {
  jackpot_type: number
  coins: number
}

/** 积分暴击二级转盘结果 */
export interface FootballCupWheelPointResult {
  point_multi: number
  points: number
}

/** 单次抽奖明细（draw_count ≤ 20 时使用 batch_details） */
export interface FootballCupWheelDrawDetail {
  normal_result: FootballCupWheelNormalResult
  jackpot_result?: FootballCupWheelJackpotResult
  point_result?: FootballCupWheelPointResult
  /** 本抽后 mini 奖池 */
  mini_jackpot_pool: number
  /** 本抽后 minor 奖池 */
  minor_jackpot_pool: number
  /** 本抽后 major 奖池 */
  major_jackpot_pool: number
}

/** 奖品类型：1 特权，2 金币，3 jackpot，4 积分暴击 */
export interface FootballCupWheelPrizeItem {
  prize_type: number
  name: string
  icon: string
  num: number
}

/** draw_count > 20 时 summary */
export interface FootballCupWheelDrawSummary {
  jackpot_prizes: FootballCupWheelJackpotResult[]
  other_prizes: FootballCupWheelPrizeItem[]
}

/**
 * `/live/game/football_cup_wheel_draw` 成功返回的 data
 * status：1 成功，2 抽奖券不足
 */
export interface FootballCupWheelDrawResult {
  err_msg: string
  status: number
  tickets: number
  /** draw_count ≤ 20：逐次明细 */
  batch_details?: FootballCupWheelDrawDetail[]
  /** draw_count > 20：汇总 */
  summary?: FootballCupWheelDrawSummary
  mini_jackpot_pool: number
  minor_jackpot_pool: number
  major_jackpot_pool: number
}
